import React from "react";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";
import { SmartImage } from "../../v2/SmartImage/SmartImage";

export type IIcon = {
    text: string;
    url: string;
    imageURL?: string | null;
    id?: string;
};

const Icon = ({ icon, carouselClassName, iconFullSize = false }: { icon: IIcon; carouselClassName: string; iconFullSize?: boolean }) => {
    return (
        <SmartLink href={icon.url} className={`Icon ${carouselClassName} relative flex w-1/5 cursor-ew-resize flex-col items-center 2xl:w-[33%]`}>
            <div className="Icon-border absolute right-0 top-[0px] h-full w-[1px] bg-accent-secondary-light" />
            <div className="Icon-image relative mx-auto flex h-[120px] w-[120px] items-center justify-center overflow-hidden rounded-full bg-accent-secondary-light">
                {icon.imageURL && (
                    <SmartImage
                        image={icon.imageURL}
                        isDecorative
                        objectFit={iconFullSize ? "cover" : undefined}
                        fill={iconFullSize ? true : undefined}
                        width={75}
                        height={75}
                        style={{
                            maxWidth: "100%"
                        }}
                    />
                )}
            </div>
            <h3 className="Icon-heading mb-0 mt-4 text-center text-sm text-text-contrast">{icon.text}</h3>
        </SmartLink>
    );
};

export default Icon;
